
import { createBrowserHistory } from "history";
import RootStore from "./stores/RootStore";

export const browserHistory = createBrowserHistory();

export const createStore = () => {
    return RootStore.create();
}